export default __webpack_public_path__ + "static/media/bathtubmiddle.df8a9949.jpg";